"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FiltersMenu = void 0;
const BasicFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/BasicFieldType"));
const StaticFieldType_1 = __importDefault(require("@opsbase/lib-data-fieldtype/StaticFieldType"));
const MetaModelRegistry_1 = __importDefault(require("@opsbase/lib-data-metamodel/MetaModelRegistry"));
const index_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldKey/index"));
const QueryFieldRegistry_1 = __importDefault(require("@opsbase/lib-data-queryfield/QueryFieldRegistry/QueryFieldRegistry"));
const StaticFieldOptionsGetterRegistry_1 = __importDefault(require("@opsbase/lib-data-staticfieldoptions/StaticFieldOptionsGetterRegistry"));
const DataType_1 = require("@opsbase/lib-datatype/DataType");
const getFromStringOrFunction_1 = require("@opsbase/lib-general/utils/getFromStringOrFunction");
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importDefault(require("@opsbase/web-css"));
const useDataTree_1 = __importDefault(require("@opsbase/web-ctrl-datatree/useDataTree"));
const useView_1 = __importDefault(require("@opsbase/web-ctrl-view/useView"));
const useViewActions_1 = __importDefault(require("@opsbase/web-ctrl-view/useViewActions"));
const FilterIcon_1 = __importDefault(require("@opsbase/web-icons/icons/FilterIcon"));
const PlaceTreeView_1 = __importDefault(require("@opsbase/web-treeview/PlaceTreeView/PlaceTreeView"));
const Button_1 = __importDefault(require("@opsbase/web-ui/Button"));
const MenuItem_1 = __importDefault(require("@opsbase/web-ui/MenuItem"));
const NonModalPopover_1 = __importDefault(require("@opsbase/web-ui/NonModalPopover"));
const react_1 = __importStar(require("react"));
const PickBoolean_1 = __importDefault(require("../pickers/PickBoolean"));
const PickDate_1 = __importDefault(require("../pickers/PickDate"));
const PickEntity_1 = __importDefault(require("../pickers/PickEntity"));
const PickNumberRange_1 = __importDefault(require("../pickers/PickNumberRange"));
const PickSPT_1 = __importDefault(require("../pickers/PickSPT"));
const PickStatic_1 = __importDefault(require("../pickers/PickStatic"));
const PickString_1 = __importDefault(require("../pickers/PickString"));
const PickTime_1 = __importDefault(require("../pickers/PickTime"));
// eslint-disable-next-line no-shadow
var MenuType;
(function (MenuType) {
    MenuType[MenuType["SEARCH"] = 0] = "SEARCH";
    MenuType[MenuType["DATE"] = 1] = "DATE";
    MenuType[MenuType["STATIC"] = 2] = "STATIC";
    MenuType[MenuType["SPT"] = 3] = "SPT";
    MenuType[MenuType["BOOLEAN"] = 4] = "BOOLEAN";
    MenuType[MenuType["STRING"] = 5] = "STRING";
    MenuType[MenuType["NUMBER"] = 6] = "NUMBER";
    MenuType[MenuType["SCORE"] = 7] = "SCORE";
    MenuType[MenuType["PLACE"] = 8] = "PLACE";
})(MenuType || (MenuType = {}));
const makeMyClasses = () => ({
    root: {
        height: '100%',
        borderRadius: '5px 0 0 5px',
    },
    mainMenu: {
        minWidth: 240,
        maxHeight: 500,
        overflow: 'auto',
        paddingTop: 8,
        paddingBottom: 8,
    },
    subMenu: {
        minWidth: 300,
        maxHeight: 500,
        overflow: 'auto',
        padding: 8,
    },
});
function FiltersMenu({ filterableSelector, }) {
    const dt = (0, useDataTree_1.default)();
    const { filters, type } = (0, useView_1.default)(dt.viewId);
    const { addFilter, toggleFilter } = (0, useViewActions_1.default)(dt.viewId);
    const [showMainMenu, setShowMainMenu] = (0, react_1.useState)(false);
    const [mainMenuCloseHandle, setMainMenuCloseHandle] = (0, react_1.useState)();
    const [subMenuState, setSubMenuState] = (0, react_1.useState)({});
    const [dateMenuState, setDateMenuState] = (0, react_1.useState)({});
    const buttonRef = (0, react_1.useRef)();
    const self = (0, useSelf_1.default)();
    const queryField = subMenuState === null || subMenuState === void 0 ? void 0 : subMenuState.queryField;
    const { filterables } = MetaModelRegistry_1.default[type];
    if (type === DataType_1.DataType.ISSUE_TODO &&
        self.showStaffIssues &&
        !filterables.find(f => f.key === index_1.default.STAFF)) {
        filterables.push(QueryFieldRegistry_1.default[index_1.default.STAFF]);
    }
    const availFilters = (0, react_1.useMemo)(() => {
        const available = filterables.filter(f => !f.hidden);
        if (filterableSelector) {
            return filterableSelector(available);
        }
        return available;
    }, [filterableSelector, filterables]);
    const hasAvailFilters = !!availFilters.length;
    const myCss = (0, web_css_1.default)(makeMyClasses);
    const handleClickButton = (0, react_1.useCallback)(() => setShowMainMenu(true), []);
    const handleCloseSubMenu = (0, react_1.useCallback)(() => {
        setDateMenuState({});
        setSubMenuState({});
        setMainMenuCloseHandle(setTimeout(() => {
            setShowMainMenu(false);
        }, 10));
    }, []);
    const handleCloseMainMenu = (0, react_1.useCallback)(() => {
        if (subMenuState.el || dateMenuState.el)
            return;
        handleCloseSubMenu();
        setShowMainMenu(false);
    }, [subMenuState, dateMenuState, handleCloseSubMenu]);
    const handleClickMainMenu = (0, react_1.useCallback)(() => {
        if (mainMenuCloseHandle)
            clearTimeout(mainMenuCloseHandle);
    }, [mainMenuCloseHandle]);
    const handleCancelDateMenu = (0, react_1.useCallback)(() => {
        setDateMenuState({});
    }, []);
    const handleSelectQueryField = (0, useCallforward_1.default)((qf) => e => {
        let el = e.target;
        while (!(el instanceof HTMLLIElement) && el.parentElement) {
            el = el.parentElement;
        }
        setDateMenuState({});
        setSubMenuState({ el, queryField: qf });
    }, []);
    const handleOpenDateFilter = (0, react_1.useCallback)((qf, subMenu) => e => {
        let el = e.target;
        while (!(el instanceof HTMLLIElement) && el.parentElement) {
            el = el.parentElement;
        }
        setDateMenuState({ el, queryField: qf, subMenu });
    }, []);
    const handleChangePlaces = (0, react_1.useCallback)(places => {
        places.map(p => {
            toggleFilter({
                queryFieldKey: index_1.default.PLACE,
                id: p === null || p === void 0 ? void 0 : p.id,
                title: p === null || p === void 0 ? void 0 : p.title,
            });
        });
    }, [toggleFilter]);
    const handleChangeFilter = (0, react_1.useCallback)((filter) => {
        toggleFilter(filter);
    }, [toggleFilter]);
    const handleAddFilter = (0, react_1.useCallback)((filter) => {
        addFilter(filter);
    }, [addFilter]);
    let fieldOptions = [];
    let menuType = MenuType.SEARCH;
    let placement = 'right-start';
    if (queryField) {
        const fieldType = queryField.fieldType;
        if (Object.values(StaticFieldType_1.default).indexOf(fieldType) >= 0) {
            fieldOptions = StaticFieldOptionsGetterRegistry_1.default[fieldType](self);
            menuType = MenuType.STATIC;
        }
        else if (queryField.key === index_1.default.PLACE) {
            menuType = MenuType.PLACE;
        }
        else {
            switch (fieldType) {
                case BasicFieldType_1.default.BOOLEAN:
                    menuType = MenuType.BOOLEAN;
                    break;
                case BasicFieldType_1.default.STRING:
                    menuType = MenuType.STRING;
                    break;
                case BasicFieldType_1.default.STRINGALT:
                    menuType = MenuType.STRING;
                    break;
                case BasicFieldType_1.default.NUMBER:
                    menuType = MenuType.NUMBER;
                    break;
                case BasicFieldType_1.default.RELATED_SPT:
                    menuType = MenuType.SPT;
                    break;
                case BasicFieldType_1.default.DATE:
                    menuType = MenuType.DATE;
                    placement = 'right';
                    break;
                case BasicFieldType_1.default.OP_SCORE:
                    menuType = MenuType.SCORE;
                    break;
            }
        }
    }
    if (!hasAvailFilters)
        return null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { ref: buttonRef, style: { height: 'auto' }, icon: react_1.default.createElement(FilterIcon_1.default, null), small: true, color: lib_palette_1.default.GoodOldBlue, onClick: handleClickButton, tooltip: lib_i18n_1.default.t('filter-your-data'), classes: { root: myCss.root } }),
        showMainMenu && (react_1.default.createElement(NonModalPopover_1.default, { id: "filtersMain", open: showMainMenu, anchorEl: buttonRef.current, onClick: handleClickMainMenu, onClose: handleCloseMainMenu, placement: "bottom-start" },
            react_1.default.createElement("div", { className: myCss.mainMenu }, availFilters.map(qf => (react_1.default.createElement(MenuItem_1.default, { key: 'filter_' + qf.key, onClick: handleSelectQueryField(qf), label: (0, getFromStringOrFunction_1.getFromStringOrFunction)(qf.label), showChevron: true, selected: qf === queryField })))))),
        subMenuState.el && subMenuState.queryField && (react_1.default.createElement(NonModalPopover_1.default, { id: "filtersSub", open: true, anchorEl: subMenuState.el, onClose: handleCloseSubMenu, placement: placement },
            react_1.default.createElement("div", { className: myCss.subMenu },
                menuType === MenuType.SEARCH && (react_1.default.createElement(PickEntity_1.default, { queryField: queryField, filters: filters, onSelect: handleChangeFilter })),
                menuType === MenuType.STATIC && (react_1.default.createElement(PickStatic_1.default, { fieldOptions: fieldOptions, filters: filters, onSelect: handleChangeFilter })),
                menuType === MenuType.PLACE && (react_1.default.createElement(PlaceTreeView_1.default, { selected: filters
                        .filter(f => f.queryFieldKey === index_1.default.PLACE)
                        .map(f => f.id), onSelect: handleChangePlaces })),
                menuType === MenuType.SPT && (react_1.default.createElement(PickSPT_1.default, { queryField: subMenuState.queryField, filters: filters, onSelect: handleChangeFilter })),
                menuType === MenuType.BOOLEAN && (react_1.default.createElement(PickBoolean_1.default, { queryField: queryField, filters: filters, onSelect: handleChangeFilter })),
                menuType === MenuType.STRING && (react_1.default.createElement(PickString_1.default, { queryField: queryField, onSelect: handleChangeFilter, onCancel: handleCloseSubMenu })),
                menuType === MenuType.NUMBER && (react_1.default.createElement(PickNumberRange_1.default, { queryField: queryField, float: true, onSelect: handleChangeFilter, onCancel: handleCloseSubMenu })),
                menuType === MenuType.SCORE && (react_1.default.createElement(PickNumberRange_1.default, { queryField: queryField, suffix: '%', minValue: 0, maxValue: 100, onSelect: v => {
                        handleAddFilter(Object.assign(Object.assign({}, v), { color: lib_palette_1.default.primary }));
                        handleCloseSubMenu();
                    }, onCancel: handleCloseSubMenu })),
                menuType === MenuType.DATE && (react_1.default.createElement("div", { style: { minWidth: 200, paddingTop: 8, paddingBottom: 8 } },
                    react_1.default.createElement(MenuItem_1.default, { key: 'filter_' + queryField.key + '_date', onClick: handleOpenDateFilter(subMenuState.queryField, 'date'), label: 'By Date', showChevron: true, selected: dateMenuState.subMenu === 'date' }),
                    react_1.default.createElement(MenuItem_1.default, { key: 'filter_' + queryField.key + '_time', onClick: handleOpenDateFilter(subMenuState.queryField, 'time'), label: 'By Time', showChevron: true, selected: dateMenuState.subMenu === 'time' }),
                    dateMenuState.el && (react_1.default.createElement(NonModalPopover_1.default, { id: "filtersSub", open: true, anchorEl: dateMenuState.el, onClose: handleCancelDateMenu, placement: placement },
                        dateMenuState.subMenu === 'date' && (react_1.default.createElement(PickDate_1.default, { queryField: subMenuState.queryField, onSelect: v => {
                                handleChangeFilter(v);
                                handleCloseSubMenu();
                            }, onCancel: handleCancelDateMenu })),
                        dateMenuState.subMenu === 'time' && (react_1.default.createElement(PickTime_1.default, { queryField: subMenuState.queryField, onSelect: v => {
                                handleChangeFilter(Object.assign(Object.assign({}, v), { id: 'time' }));
                                handleCloseSubMenu();
                            }, onCancel: handleCancelDateMenu })))))))))));
}
exports.FiltersMenu = FiltersMenu;
exports.default = FiltersMenu;
